import { useMutation, useQueryCache } from 'react-query';
import { createDrug } from 'src/services/api/drugs';

function useCreateDrug() {
  const queryCache = useQueryCache();

  return useMutation((data) => createDrug(data), {
    onSuccess: (data) => queryCache.setQueryData(['drug', data.data?.id], data),
  });
}

export default useCreateDrug;
